import React from 'react'
import DefaultLeadsPage from '../../components/LeadsDataWithFilter/index';

function index() {
  return (
    <DefaultLeadsPage leadType="Ola"/>
  )
}

export default index